import React from 'react'

const Loading = ({color, size}) => {   
  return (
    <div style={{backgroundColor:color, width:size, height:size}} className='loader'>
        {/* berkant */}
    </div>
  )
}

export default Loading